import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFormModel, DynamicFormService, DynamicInputModel, DynamicTextAreaModel } from '@ng-dynamic-forms/core';
import { Store } from '@ngrx/store';
import { CartActions, StateWithMultiCart } from '@spartacus/cart/base/core';
import {
  AuthService,
  CmsService,
  GlobalMessageService,
  GlobalMessageType,
  RoutingService,
  UserIdService,
} from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { CartExtendService } from 'src/app/service/cart/cart-extend.service';
import { ComponentService } from 'src/app/service/component.service';
import { GoogleTagManagerService } from 'src/app/service/googletagmanager/google-tag-manager.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';

@Component({
  selector: 'app-save-cart-modal',
  templateUrl: './save-cart-modal.component.html',
  styleUrls: ['./save-cart-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SaveCartModalComponent implements OnInit, OnDestroy {
  formGroup: FormGroup;
  formModel: DynamicFormModel;
  cartId: string;
  userCurrent$: Observable<string> = this.userIdService.getUserId();
  saveCartDetailsFormModelSubscription$: Subscription;
  saveCartDetailsFormGroupSubscription$: Subscription;
  activeLanguage$: Observable<string> = this.languageService.getActive();

  constructor(
    protected modalService: StandardModalService,
    private cartService: CartExtendService,
    private formService: DynamicFormService,
    protected cmsService: CmsService,
    private routing: RoutingService,
    protected store: Store<StateWithMultiCart>,
    private auth: AuthService,
    private messageService: GlobalMessageService,
    private componentService: ComponentService,
    private gtmService: GoogleTagManagerService,
    private languageService: ShimanoLanguageService,
    private userIdService: UserIdService
  ) {}

  ngOnInit() {
    this.saveCartDetailsFormGroupSubscription$ = this.componentService.dynamicFormGroup$.subscribe(
      (savedCartDetailsFormGroup) => {
        this.updateFormGroup(savedCartDetailsFormGroup);
      }
    );

    this.saveCartDetailsFormModelSubscription$ = this.componentService.dynamicFormModel$.subscribe(
      (savedCartDetailsFormModel) => {
        this.updateFormModel(savedCartDetailsFormModel);
      }
    );
  }

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  saveCart(form: any) {
    if (this.formGroup && this.formGroup.valid) {
      this.cartService
        .getActiveCartId()
        .pipe(map((data) => data))
        .subscribe((results) => {
          this.cartId = results;
        })
        .unsubscribe();

      this.componentService.setIsSavingCart(true);

      const SAVE_CART_MODAL_FORM = {
        name: form.value.SAVE_CART_MODAL_FORM.saveCartName,
        description: form.value.SAVE_CART_MODAL_FORM.saveCartDescription,
      };

      this.cartService.saveCart(SAVE_CART_MODAL_FORM, this.cartId).subscribe((data: any) => {
        this.messageService.add(
          {
            key: 'cart.savedCart.modalInCart.saveCartSuccess',
            params: { cartDesc: form.value.SAVE_CART_MODAL_FORM.saveCartName },
          },
          GlobalMessageType.MSG_TYPE_CONFIRMATION
        );
        this.closeModal('redirect');
        this.store.dispatch(
          new CartActions.LoadCart({
            userId: this.userCurrent,
            cartId: data.savedCartData.code,
            extraData: {
              active: true,
            },
          })
        );
        this.routing.goByUrl('/saved-cart');
      });
    } else {
      return;
    }
  }

  updateFormGroup(form: any): void {
    this.formGroup = form;
  }
  updateFormModel(form: any): void {
    this.formModel = form;
    const saveCartTitleInput = this.formService.findModelById<DynamicInputModel>('saveCartName', this.formModel);
    const saveCartDescriptionInput = this.formService.findModelById<DynamicTextAreaModel>(
      'saveCartDescription',
      this.formModel
    );

    if (saveCartTitleInput !== null) {
      saveCartTitleInput.maxLength = 255;
      this.formService.detectChanges();
    }

    if (saveCartDescriptionInput !== null) {
      saveCartDescriptionInput.maxLength = 255;
      this.formService.detectChanges();
    }
  }

  closeModal(info?: any) {
    this.modalService.closeDialog(info);
  }

  ngOnDestroy(): void {
    if (this.saveCartDetailsFormModelSubscription$) {
      this.saveCartDetailsFormModelSubscription$.unsubscribe();
    }
    if (this.saveCartDetailsFormGroupSubscription$) {
      this.saveCartDetailsFormGroupSubscription$.unsubscribe();
    }
  }
}
